import { render } from "./listResultAdmissionSentMail.vue?vue&type=template&id=0b50f038&ts=true"
import script from "./listResultAdmissionSentMail.vue?vue&type=script&lang=ts"
export * from "./listResultAdmissionSentMail.vue?vue&type=script&lang=ts"

import "./listResultAdmissionSentMail.vue?vue&type=style&index=0&id=0b50f038&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__